module.exports = "/_next/static/images/snowflakes-background-0945ea4d002c40c1f5a35466b8141158.svg";